import { type PropsWithChildren } from 'react';

import CloseIcon from '@/assets/svg/bx-x.svg?react';
import { Button } from '@/components/buttons';
import TooltipTitle from '@/components/Flare/guides/TooltipTitle';
import { CLICK_OUTSIDE_IGNORE_ATTRIBUTE } from '@/helper/didClickOnStickyPopover';
import { cn } from '@/lib/utils';

type Props = {
  ['data-testid']?: string | false;
  title?: string;
  sticky?: boolean;
  onClose?: () => void;
};

const MultiSeriesTooltip = ({
  'data-testid': dataTestId,
  title,
  sticky,
  children,
  onClose,
}: PropsWithChildren<Props>) => {
  const clickOutsideIgnoreProps = sticky
    ? ({ [CLICK_OUTSIDE_IGNORE_ATTRIBUTE]: true } as const)
    : undefined;

  return (
    <div className="-m-5 p-5" {...clickOutsideIgnoreProps}>
      <table
        data-testid={dataTestId}
        className={cn('min-w-50 px-1.5 py-3', { 'pointer-events-auto': sticky })}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <thead>
            <TooltipTitle>{title}</TooltipTitle>
          </thead>
        )}
        <tbody>{children}</tbody>
      </table>

      {sticky && (
        <Button
          className="absolute top-1.5 right-1.5"
          variant="ghost"
          inverse
          size="icon-small"
          onClick={onClose}
        >
          <CloseIcon />
        </Button>
      )}
    </div>
  );
};

export default MultiSeriesTooltip;
